import {
  getPermissionListQueryKey,
  permissionList,
  usePermissionList,
} from "@/api/generated/endpoints/api"

export const permissionApi = {
  usePermissionList,
  permissionList,
  getPermissionListQueryKey,
}
